import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import {
    getInterlinkHomepageData,
} from 'wanderu-service-wapi';

import {
    setInterlinkHomepageData,
} from '../../appstate/actions';
import DUCK_NAMESPACE from '../../types';

const NAMESPACE = 'ACTIONS/FETCH_HOMEPAGE_INTERLINKS';

const logger = Logger.getLogger('wanderu-ducks-interlink');

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(NAMESPACE, DUCK_NAMESPACE);

function fetchHomepageInterlinks(params = {}) {
    const {
        locale,
    } = params;

    return async (dispatch) => {
        let error = null;

        dispatch(actions.startWork());

        try {
            const { result } = await getInterlinkHomepageData({
                locale,
            });

            return dispatch(setInterlinkHomepageData(result, locale));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchHomepageInterlinks', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = ex;
        } finally {
            dispatch(actions.endWork(undefined, undefined, error));
        }
    };
}

function selectNotFound(appState) {
    const opStatus = selectors.defaultSelector(appState);

    return opStatus && !opStatus.working
        && opStatus.error
        && opStatus.error.code === 'INVALID_QUERY';
}

const fetchHomepageInterlinksAction = {
    fetchHomepageInterlinks,
    reset: actions.reset,
    ...selectors,
    selectNotFound,
};

export {
    fetchHomepageInterlinksAction,
    NAMESPACE as namespace,
};
export default {
    [NAMESPACE]: reducer,
};
